/******************** TEST ********************/
/*import React from 'react';
import ReactDOM from 'react-dom';*/
/******************** TEST ********************/

/******************** BUILD ********************/
import less from '../index.less';
/******************** BUILD ********************/

class Contacto extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      configurations: {}
    };
    this.page = _spPageContextInfo.webTitle === 'Consorcio Salud' ? 'Salud' : ( _spPageContextInfo.webTitle === 'Plan Complementario' ? 'PC' : 'PBS' );
    this.pnpService = new ServicioPnp();
    this.hideDiv  = this.hideDiv.bind(this);
  }

  componentDidMount() {
    const configurations = {};
    this.pnpService.getList('parametrosPaginas', (list) => {
      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote == 'false' ? false : item.CSValorNote;
        configurations[item.CSNombreText + 'CSVisibleBool'] = item.CSVisibleBool;
      });
      if (configurations['ContactoCSVisibleBool']) {
        this.setState({ configurations });
      } else {
        this.hideDiv();
      }
    }, "(CSFormularioChoice eq 'Home " + this.page + "') and (CSNombreText eq 'Contacto')", 'CSNombreText', 'CSValorNote', 'CSVisibleBool');
  }

  hideDiv() {
    $(this.refs['container-div']).addClass('hidden');
    const thiscol = $(this.refs['container-div']).closest('.home-component-container');
    const othercol = $(this.refs['container-div']).closest('.row').find('.home-component-container').not(thiscol);
    if((thiscol[0] && othercol[0]) && (thiscol.find('.home-component').length == thiscol.find('.home-component.hidden').length)) {
      thiscol.addClass('hidden');
      othercol.removeClass('col-sm-5').removeClass('col-sm-6').removeClass('col-sm-7').addClass('col-sm-12');
    }
  }

  render() {
      return (
        <div className="contacto home-component" ref="container-div">
          { this.state.configurations['ContactoCSVisibleBool'] &&  
            <iframe src="https://form.jotformz.com/62715341065653"></iframe>
          }
        </div>
      );
  }
}

/******************** BUILD ********************/
const appId = document.getElementById('contacto');
ReactDOM.render(<Contacto />, appId);
/******************** BUILD ********************/

/******************** TEST ********************/
//export default App;
/******************** TEST ********************/


// WEBPACK FOOTER //
// ./home/components/contacto/src/index.js